import React from 'react'

const defaultTrack = (event: string, details?: any) => {}

export type ContextProps = {
  track: (event: string, details?: any) => void
}

export default React.createContext<ContextProps>({ track: defaultTrack })
